export const helper = {
    // Muss mit ProductFinderController.php zusammenpassen.
    // filter1:wert1_wert2;filter2:wert3;filter3:wert4__wert5
    generateHash: (filters) => {
        const filterKeys = Object.keys(filters);
        let fParameter = '';

        filterKeys.forEach((key, index) => {
            if (filters[key].length) {
                fParameter += `${key}:${filters[key].join('__')}`
            }

            if (index < filterKeys.length - 1) {
                fParameter += ";"
            }
        });

        if (fParameter === '') {
            return "start"
        } else {
            return fParameter;
        }
    },
    // Muss mit ProductFinderController.php zusammenpassen.
    // hash ist #filter1:wert1_wert2;filter2:wert3;filter3:wert4__wert5
    /*
    {
        "color":{
            "value":["gelb"],
            "type":"colors",
            "reference":{"value":"gelb","colors":["F8EDD7","F7E600","FABA00"]}
        },
        "collection":{
            "value":["Design Collection","DST Collection"],
            "type":"select"
        },
        "colorscheme":{
            "value":["Over the rainbow"],
            "type":"select"
        }
    }
    */
    getInitialStateFromHash: (filterByName) => {
        let initialState = {
            filterConfig: null,
            offset: 0
        };
        if (window.location.hash.length > 1) {
            const filterConfig = {};
            if (window.location.hash !== "#start") {
                const hash = window.location.hash.substr(1);

                const [filterHash, offset] = hash.split('#');
                if (offset) {
                    if (offset.indexOf(',') > 0) {
                        const [resultOffset, scrollOffset] = offset.split(',');
                        initialState.offset = resultOffset;
                        initialState.scrollY = scrollOffset;
                    }
                    else {
                        initialState.offset = offset;
                    }
                }

                if (filterHash !== 'start') {
                    const filters = filterHash.split(';');
                    filters.forEach(filter => {
                        const [name, values] = filter.split(':', 2);
                        // Make sure filter exists
                        if (filterByName(name) || name === 'samples') { // Sonderfall für durchgereichte sample-Flag für Dekore aus Shop-Startseite
                            const valuesArr = values.split('__');
                            valuesArr.forEach((value, index) => {
                                valuesArr[index] = decodeURIComponent(value)
                            });
                            filterConfig[name] = valuesArr;
                        }
                    });
                }
            }

            initialState.filterConfig = filterConfig;

        }
        return initialState;
    }
};
